import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M6.66 3a2 2 0 0 0-1.84 1.212l-2.143 5A2 2 0 0 0 4.517 12H5v9a2 2 0 0 0 2 2h12v2a1 1 0 1 0 2 0v-2h2v2a1 1 0 1 0 2 0v-2a2 2 0 0 0 2-2v-9h.483a2 2 0 0 0 1.839-2.788l-2.143-5A2 2 0 0 0 25.34 3H6.659ZM16 21v-5a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v5H7v-9h18v9h-9ZM6.66 5h18.68l2.143 5H4.517l2.142-5ZM14 21h-3v-4h3v4Z" clip-rule="evenodd"></path><path d="M8 25a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z"></path><path d="M8 27a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2H8Z"></path></g>';
export var ManufacturedOutlineSVG = function ManufacturedOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ManufacturedOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ManufacturedOutlineSVG);